import React from 'react';
import { useTranslation } from 'react-i18next';
import PromoBadge, { PromoBadgeProps } from '@wix/da-ds/pkg/Badges/PromoBadge';
import SimpleTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SimpleTooltip';

interface Props extends PromoBadgeProps {}

/** We have to wrap this badge with a tooltip outside of da-ds since tooltips still live in da-shared-react */
const PromoBadgeWithTooltip: React.FC<Props> = ({ isLocked, ...rest }) => {
  const { t } = useTranslation();
  return (
    <SimpleTooltip
      placement="bottom"
      text={t(isLocked ? 'promoBadge.locked.tooltip' : 'promoBadge.unlocked.tooltip')}
    >
      <PromoBadge isLocked={isLocked} {...rest} />
    </SimpleTooltip>
  );
};
PromoBadgeWithTooltip.displayName = 'PromoBadgeWithTooltip';

export default PromoBadgeWithTooltip;
